export enum BatchStatusExcludeTDP {
  New = 'New',
  Draft = 'Draft',
  FillSitePending = 'FillSitePending',
  FillSiteInReview = 'FillSiteInReview',
  FillSiteRejected = 'FillSiteRejected',
  QPPending = 'QPPending',
  QPInReview = 'QPInReview',
  QPRejected = 'QPRejected',
  Approved = 'Approved',
  Inprogress = 'Inprogress',
  BatchExtraPending = 'BatchExtraPending',
  Complete = 'Complete',
  Archive = 'Archive'
}
